/* ==========================================================================
   SNC Cart — NaturaFusión
   Add-to-cart AJAX global por delegación de eventos sobre [data-snc-atc].
   Mantiene el patrón existente: /cart/add.js -> /cart.js -> evento
   'snc:cart:updated' (escuchado por el header para el badge) + toast.
   ========================================================================== */
(function () {
  if (window.__sncCartInit) return;
  window.__sncCartInit = true;

  function toast(msg) {
    var t = document.getElementById('snc-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'snc-toast';
      t.className = 'snc-toast';
      t.setAttribute('aria-live', 'polite');
      t.setAttribute('aria-atomic', 'true');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    // reflow para reiniciar la transición si ya estaba visible
    void t.offsetWidth;
    t.classList.add('is-visible');
    clearTimeout(t._sncTimer);
    t._sncTimer = setTimeout(function () {
      t.classList.remove('is-visible');
    }, 2600);
  }
  window.sncToast = toast;

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;

    var title = btn.getAttribute('data-product-title') || 'Producto';
    var label = btn.querySelector('.snc-card__btn-label') || btn;
    var orig = label.textContent;

    btn.disabled = true;
    btn.classList.add('is-loading');
    label.textContent = 'Agregando';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        label.textContent = '¡Agregado!';
        toast('✓ ' + title + ' agregado al carrito');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          document.dispatchEvent(new CustomEvent('snc:cart:updated', {
            detail: { item_count: cart.item_count }
          }));
        }
      })
      .catch(function () {
        label.textContent = 'Error, reintenta';
      })
      .finally(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          label.textContent = orig;
        }, 2000);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-snc-atc]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });
})();
